
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/filter",
      function () {
        return require("private-next-pages/search/filter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/filter"])
      });
    }
  